import { Component, HostBinding } from '@angular/core';
import { UtilityService } from '@mono-repo/util';
import { ConfigService } from '../../config.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent {
  @HostBinding('class') class = 'dt-error dt-c-interactive-dialog';
  public route: string =
    this.utilityService.getSourceUrl4Ever() || `/${this.configService.getConfig()?.initialRoute || ''}`;

  constructor(
    private readonly utilityService: UtilityService,
    private readonly configService: ConfigService,
  ) {}
}
